import { useState, useEffect } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import {
  __experimentalHStack as HStack,
  __experimentalText as Text,
  __experimentalToolsPanel as ToolsPanel,
  __experimentalToolsPanelItem as ToolsPanelItem,
  Button,
  Popover,
} from '@wordpress/components';
import {
  arrowDown,
  arrowLeft,
  arrowRight,
  arrowUp,
  chevronDown,
  chevronLeft,
  chevronRight,
  chevronUp,
  chevronUpDown,
  lock,
} from '@wordpress/icons';

const IconPicker = ({ Icon, onIconSelect }) => {
  const [isPopoverVisible, setIsPopoverVisible] = useState(false);
  const [popoverAnchor, setPopoverAnchor] = useState();
  const [selectedIcon, setSelectedIcon] = useState(Icon);

  // Ensure state syncs with prop if `Icon` changes
  useEffect(() => {
    setSelectedIcon(Icon || 'none');
  }, [Icon]);

  const togglePopover = () => {
    setIsPopoverVisible((prev) => !prev);
  };

  const handleIconClick = (icon) => {
    setSelectedIcon(icon);
    onIconSelect(icon); // Update parent with selected icon
    setIsPopoverVisible(false); // Close the popover after selecting
  };

  const iconOptions = [
    { label: __('None', 'vayu-blocks'), value: 'none', icon: lock }, // Placeholder for no icon
    { label: __('Arrow Down', 'vayu-blocks'), value: 'arrowDown', icon: arrowDown },
    { label: __('Arrow Left', 'vayu-blocks'), value: 'arrowLeft', icon: arrowLeft },
    { label: __('Arrow Right', 'vayu-blocks'), value: 'arrowRight', icon: arrowRight },
    { label: __('Arrow Up', 'vayu-blocks'), value: 'arrowUp', icon: arrowUp },
    { label: __('Chevron Down', 'vayu-blocks'), value: 'chevronDown', icon: chevronDown },
    { label: __('Chevron Left', 'vayu-blocks'), value: 'chevronLeft', icon: chevronLeft },
    { label: __('Chevron Right', 'vayu-blocks'), value: 'chevronRight', icon: chevronRight },
    { label: __('Chevron Up', 'vayu-blocks'), value: 'chevronUp', icon: chevronUp },
    { label: __('Chevron Up Down', 'vayu-blocks'), value: 'chevronUpDown', icon: chevronUpDown },
  ];

  const selectedOption = iconOptions.find((option) => option.value === selectedIcon);
  const iconDisplay = selectedOption ? selectedOption.icon : lock;

  return (
    <div className="vayu_blocks_icon_picker_panel">
      <ToolsPanel label={__('Button Icon')} className="vayu_blocks_icon_picker_name">
      <ToolsPanelItem
      label={__('Icon')}
			hasValue={() => !!selectedIcon}
			onDeselect={() => handleIconClick(null)}
			isShownByDefault
		 >
      <Button
        ref={setPopoverAnchor}
        onClick={togglePopover}
        className={`block-editor-panel-icon-settings__dropdown ${
          isPopoverVisible ? 'is-open' : ''
        }`}
      >
        <HStack alignment="left">
          {selectedOption?.value === 'none' ? (
            <div className="vayu-blocks-panel-ihover vayu-blocks-none-button vb-none-icon-picker vb-display-tools-none"></div>
          ) : (
            <span className="vb-display-tools-other icon-display" style={{ fontSize: '1.3rem' }}>
              {iconDisplay}
            </span>
          )}
          <Text>{selectedOption ? selectedOption.label : __('None', 'vayu-blocks')}</Text>
        </HStack>
      </Button>
      </ToolsPanelItem>
      </ToolsPanel>

      {isPopoverVisible && (
        <Popover
          placement="left-start"
          className="vayu_blocks_toolspanel_items_popover"
          anchor={popoverAnchor}
          onClose={() => setIsPopoverVisible(false)}
          offset={35}
          resize
        >
          <div className="vayu_blocks_icon_picker">
            <h4>{__('Select Icon')}</h4>
            <p>{__('Choose an icon for your element or select "None".')}</p>
            <div className="vayu-blocks-icon-picker-grid">
             {iconOptions.map((option) => {
                  return (
                    <div
                      key={option.value}
                      className={`vayu_blocks-icon-option ${
                        selectedIcon === option.value ? 'selected' : ''
                      }`}
                      onClick={() => handleIconClick(option.value)}
                      title={option.label}
                    >
                      {option.value === 'none' ? (
                        <div className="vayu-blocks-panel-ihover vayu-blocks-none-button vb-none-icon-picker"></div>
                      ) : (
                        <span className="icon-display">{option.icon}</span>
                      )}

                    </div>
                  );
              })}
            </div>
          </div>
        </Popover>
      )}
    </div>
  );
};

export default IconPicker;
